/**
 * MUI DataGrid styles aligned with the V4 Search EnrichmentGrid results table.
 */

import { getFilterBandBackground } from "../../components/layouts/SubHeader/subHeaderBannerStyles";

/**
 * Content shell under the banner — same gradient band as Search/Conferences
 * so the table blends smoothly out of the banner wash.
 */
export const savedSearchListGradientBandSx = {
  width: "100%",
  px: { xs: 2, md: "40px" },
  pt: { xs: 2, md: "32px" },
  pb: { xs: 2, md: "40px" },
  boxSizing: "border-box",
  background: (theme) => getFilterBandBackground(theme),
};

export const savedSearchListTableShellSx = (theme) => ({
  // Height follows the row list (same content-sized model as EnrichmentGrid).
  height: "auto",
  width: "100%",
  bgcolor: "background.paper",
  borderRadius: { xs: "12px", md: "10px" },
  border: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : "rgba(88,89,91,0.12)"
  }`,
  overflow: "hidden",
  boxShadow: "none",
});

const listColumns = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 150px 200px 110px",
  columnGap: 0,
  alignItems: "center",
  px: 2,
  boxSizing: "border-box",
};

export const savedSearchListHeaderSx = (theme) => {
  const isDark = theme.palette.mode === "dark";
  const headerBg = isDark ? "#2A2A2A" : "#FFFFFF";
  const divider = theme.palette.divider;

  return {
    ...listColumns,
    flexShrink: 0,
    minHeight: 44,
    maxHeight: 44,
    backgroundColor: headerBg,
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${divider}`,
  };
};

export const savedSearchListScrollSx = (theme) => ({
  // No inner vertical scroll viewport — page scroll owns overflow.
  overflow: "visible",
  backgroundColor: theme.palette.background.paper,
});

export const savedSearchListRowSx = (theme, index, rowHeight = 44) => {
  const isDark = theme.palette.mode === "dark";
  const stripeBg = isDark ? "rgba(255, 255, 255, 0.03)" : "rgba(0, 0, 0, 0.02)";
  const hoverBg = theme.palette.action.hover;
  const divider = theme.palette.divider;

  return {
    ...listColumns,
    // EnrichmentGrid V2 base row height (44px) — fixed, never stretched.
    minHeight: rowHeight,
    height: rowHeight,
    maxHeight: rowHeight,
    boxSizing: "border-box",
    overflow: "hidden",
    cursor: "pointer",
    borderBottom: `1px solid ${divider}`,
    backgroundColor:
      index % 2 === 1 ? stripeBg : theme.palette.background.paper,
    "&:hover": {
      backgroundColor: hoverBg,
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
  };
};
